import { useI18N } from "@sundae/react-hooks";
import { Balance, NumberI18N, Tooltip, toolkitCx } from "@sundae/ui-toolkit";
import { AssetAmount } from "@sundaeswap/asset";
import cx from "classnames";
import { FC } from "react";
import AssetAvatar from "../../../../components/AssetAvatar";
import { useAssetMetadata } from "../../../../gql/hooks/assets.query";
import { useRollupQuery } from "../../../../gql/hooks/farms.query";
import NoDataText from "../../../../i18n/components/warnings/NoDataText";

interface IProgramDailyRewardsProps {
  emittedAssetId: string;
  rollupKey: string;
}

const ProgramDailyRewards: FC<IProgramDailyRewardsProps> = ({ rollupKey, emittedAssetId }) => {
  const { currentLocale } = useI18N("farms");
  const { data } = useRollupQuery(rollupKey);
  const { data: assetsByIds } = useAssetMetadata([emittedAssetId]);

  const emittedAsset = assetsByIds?.stats.find(({ assetId }) => assetId === emittedAssetId);

  if (!data || !emittedAsset) {
    return <div className={cx("h-3 w-full", toolkitCx.layout.background.loading)} />;
  }

  if (Object.values(data).every((value) => value === 0)) {
    return <NoDataText />;
  }

  const { emitted } = data;

  return (
    <div className="flex w-fit items-center gap-2">
      <AssetAvatar asset={emittedAsset} size="sm" />
      <Tooltip
        trigger={
          <Balance
            locale={currentLocale}
            showSymbol={false}
            size="sm"
            value={new AssetAmount(emitted, emittedAsset.decimals)}
          />
        }
        tooltipLabel={
          <NumberI18N
            locale={currentLocale}
            size="sm"
            value={new AssetAmount(emitted, emittedAsset.decimals).value.toNumber()}
          />
        }
      />
    </div>
  );
};

export default ProgramDailyRewards;
